export const avatar = 'assets/images/no-picture.jpg';

// Import types from proxy
import { ColumnListPreferences } from '@proxy/settings/models';

export const datatablePrintStyle: { [selector: string]: { [prop: string]: string } } = {
  '.datatable-footer-inner': { display: 'none' },
  '.datatable-checkbox': { display: 'none' },
  '.datatable-row-right': { display: 'none' },
  'html, body': { overflow: 'visible !important' },
  'ngx-datatable': {
    display: 'block !important',
    height: 'auto !important',
    overflow: 'visible !important',
  },
  'datatable-header': {
    display: 'block !important',
    height: 'auto !important',
    overflow: 'visible !important',
  },
  'datatable-body': {
    display: 'block !important',
    height: 'auto !important',
    overflow: 'visible !important',
  },
  'datatable-selection': { display: 'block !important', height: 'auto !important' },
  'datatable-scroller': {
    display: 'block !important',
    height: 'auto !important',
    width: '100% !important',
    overflow: 'visible !important',
  },
  'datatable-row-wrapper': { display: 'block !important' },
};

/**
 * Default user preferences matching backend DefaultUserPreferences class
 * Uses Dictionary<string, ColumnConfig> structure from backend
 */
export const defaultAssetPreferences: ColumnListPreferences = {
  columns: {
    primaryID: { visible: true, mandatory: true, default: true, order: 1, width: 0 },
    categoryNickname: { visible: true, mandatory: false, default: true, order: 2, width: 0 },
    secondaryID: { visible: true, mandatory: false, default: true, order: 3, width: 0 },
    categoryFullName: { visible: false, mandatory: false, default: false, order: 4, width: 0 },
    hours: { visible: false, mandatory: false, default: false, order: 5, width: 0 },
    kilometers: { visible: false, mandatory: false, default: false, order: 6, width: 0 },
    homeLocationName: { visible: true, mandatory: false, default: true, order: 7, width: 0 },
    secondaryLocationName: { visible: true, mandatory: false, default: true, order: 8, width: 0 },
    jobsiteNames: { visible: false, mandatory: false, default: false, order: 9, width: 0 },
    targetLocationName: { visible: false, mandatory: false, default: false, order: 10, width: 0 },
    availability: { visible: false, mandatory: false, default: false, order: 11, width: 0 },
    assetType: { visible: false, mandatory: false, default: false, order: 12, width: 0 },
    status: { visible: false, mandatory: false, default: false, order: 13, width: 0 },
    offhireDate: { visible: false, mandatory: false, default: false, order: 14, width: 0 },
    nextEventDueHours: { visible: false, mandatory: false, default: false, order: 16, width: 0 },
    nextEventDueKm: { visible: false, mandatory: false, default: false, order: 17, width: 0 },
    nextEvent: { visible: false, mandatory: false, default: false, order: 18, width: 0 },
    compliance: { visible: false, mandatory: false, default: false, order: 19, width: 0 },
    lastSeen: { visible: false, mandatory: false, default: false, order: 20, width: 0 },
    manufacturerName: { visible: false, mandatory: false, default: false, order: 21, width: 0 },
    modelName: { visible: false, mandatory: false, default: false, order: 22, width: 0 },
    requestNumber: { visible: false, mandatory: false, default: false, order: 23, width: 0 },
    rfid: { visible: false, mandatory: false, default: false, order: 24, width: 0 },
    runningCost: { visible: false, mandatory: false, default: false, order: 25, width: 0 },
    secondaryTracker: { visible: false, mandatory: false, default: false, order: 26, width: 0 },
    tracker: { visible: false, mandatory: false, default: false, order: 27, width: 0 },
    barcode: { visible: false, mandatory: false, default: false, order: 28, width: 0 },
    costCentre: { visible: false, mandatory: false, default: false, order: 29, width: 0 },
    limits: { visible: false, mandatory: false, default: false, order: 30, width: 0 },
    matched: { visible: false, mandatory: false, default: false, order: 31, width: 0 },
    picture: { visible: false, mandatory: false, default: false, order: 32, width: 0 },
  },
};

export const defaultInspectionPreferences: ColumnListPreferences = {
  columns: {
    picture: { visible: true, mandatory: false, default: true, order: 1, width: 0 },
    assetPrimaryID: { visible: true, mandatory: true, default: true, order: 2, width: 0 },
    targetLocationName: { visible: true, mandatory: false, default: true, order: 3, width: 0 },
    inspectionTypeName: { visible: true, mandatory: false, default: true, order: 4, width: 0 },
    assetSecondaryID: { visible: true, mandatory: false, default: true, order: 5, width: 0 },
    categoryNickname: { visible: true, mandatory: false, default: true, order: 6, width: 0 },
    categoryFullName: { visible: false, mandatory: false, default: false, order: 7, width: 0 },
    doneOn: { visible: true, mandatory: false, default: true, order: 8, width: 0 },
    dueOn: { visible: true, mandatory: false, default: true, order: 9, width: 0 },
    currentHours: { visible: false, mandatory: false, default: false, order: 10, width: 0 },
    hourLimit: { visible: false, mandatory: false, default: false, order: 11, width: 0 },
    currentKm: { visible: false, mandatory: false, default: false, order: 12, width: 0 },
    kmLimit: { visible: false, mandatory: false, default: false, order: 13, width: 0 },
    currentMile: { visible: false, mandatory: false, default: false, order: 14, width: 0 },
    mileLimit: { visible: false, mandatory: false, default: false, order: 15, width: 0 },
    inspectionStatusName: { visible: true, mandatory: false, default: true, order: 16, width: 0 },
    reportNumber: { visible: false, mandatory: false, default: false, order: 18, width: 0 },
    notes: { visible: false, mandatory: false, default: false, order: 19, width: 0 },
    hasConsumables: { visible: false, mandatory: false, default: false, order: 20, width: 0 },
    runningCost: { visible: false, mandatory: false, default: false, order: 21, width: 0 },
    operatorName: { visible: false, mandatory: false, default: false, order: 22, width: 0 },
    jobNumber: { visible: false, mandatory: false, default: false, order: 23, width: 0 },
    state: { visible: false, mandatory: false, default: false, order: 24, width: 0 },
    recurrence: { visible: false, mandatory: false, default: false, order: 25, width: 0 },
    consumables: { visible: false, mandatory: false, default: false, order: 26, width: 0 },
    eventType: { visible: false, mandatory: false, default: false, order: 27, width: 0 },
  },
};

export const locationTypesForConsumables = [
  'Main Storage',
  'FieldStorage/Container (In Use)',
  'FieldStorage/Container (Not In Use)',
  'Loft Store',
  'A Vehicle',
  'Jobsite Storage',
];

export const consumableLocationTypes = [
  'A Person',
  'A Infoganic User',
  'Third Party',
  'A Vehicle',
  'Jobsite',
];

export const notConsumableLocationTypes = ['Quarantine', 'Jobsite AC'];

export const assetFields: { [x: string]: boolean } = {
  primaryID: true,
  secondaryID: true,
  categoryFullName: false,
  categoryNickname: false,
  notes: false,
  barcode: false,
  rfid: false,
  homeLocationName: false,
  secondaryLocationName: false,
  jobsiteNames: false,
  manufacturerName: false,
  modelName: false,
  standartComplianceStatus: false,
  jobsiteComplianceStatus: false,
  deviceNames: false,
  orderNumber: false,
  targetLocationName: false,
  hours: false,
  kilometers: false,
  eventCost: false,
};

export const inspectionFields: { [x: string]: boolean } = {
  inspectionTypeName: true,
  doneOn: true,
  dueOn: false,
  inspectionStatusName: false,
  notes: false,
  eventCost: false,
  consumables: false,
  operatorName: false,
  hoursLimit: false,
  currentHours: false,
  kmLimit: false,
  currentKm: false,
};

export const assetColumnsTranslationKey = {
  availability: 'RegisterService::Availability',
  assetType: 'ServicingService::Type',
  offhireDate: 'RegisterService::OffhireDate',
  nextEventDueHours: 'RegisterService::DueHrs',
  nextEventDueKm: 'RegisterService::DueKm',
  nextEvent: 'QueueService::NextEvent',
  compliance: 'RegisterService::Compliance',
  lastSeen: 'RegisterService::LastSeen',
  rfid: 'RegisterService::Rfid',
  manufacturerName: 'RegisterService::Manufacturer',
  modelName: 'RegisterService::Model',
  tracker: 'RegisterService::Tracker',
  secondaryTracker: 'RegisterService::SecondaryTracker',
  requestNumber: 'RegisterService::RequestNumber',
  runningCost: 'RegisterService::TotalCost',
  hasAttributes: 'RegisterService::CustomAttributes',
  limits: 'RegisterService::DueHrsKm',
  costCentre: 'RegisterService::CostCentre',
  targetLocation: 'RegisterService::TargetLocation',
  hours: 'RegisterService::Hours',
  kilometers: 'RegisterService::KM',
  matched: 'RegisterService::Matched',
  primaryID: 'RegisterService::PrimaryID',
  secondaryID: 'RegisterService::SecondaryID',
  categoryFullName: 'RegisterService::Categories',
  categoryNickname: 'RegisterService::Nickname',
  barcode: 'RegisterService::Barcode',
  homeLocationName: 'RegisterService::HomeLocation',
  secondaryLocationName: 'RegisterService::SecondaryLocations',
  jobsiteNames: 'RegisterService::Jobsites',
  standartComplianceStatus: 'RegisterService::StandardCompliance',
  jobsiteComplianceStatus: 'RegisterService::JobsiteCompliance',
  targetLocationName: 'RegisterService::EventLocation',
  deviceNames: 'RegisterService::Tracker',
  orderNumber: 'RegisterService::RequestNumber',
  status: 'ServicingService::Status',
  picture: 'RegisterService::Picture',
};

export const inspectionColumnsTranslationKey = {
  assetPrimaryID: 'RegisterService::PrimaryID',
  assetSecondaryID: 'RegisterService::SecondaryID',
  categoryFullName: 'RegisterService::Categories',
  categoryNickname: 'RegisterService::Nickname',
  barcode: 'RegisterService::Barcode',
  homeLocationName: 'RegisterService::HomeLocation',
  secondaryLocationName: 'RegisterService::SecondaryLocations',
  jobsiteNames: 'RegisterService::Jobsites',
  standartComplianceStatus: 'RegisterService::StandardCompliance',
  jobsiteComplianceStatus: 'RegisterService::JobsiteCompliance',
  targetLocationName: 'RegisterService::EventLocation',
  deviceNames: 'RegisterService::Tracker',
  orderNumber: 'RegisterService::RequestNumber',
  inspectionTypeName: 'ServicingService::EventType',
  inspectionStatusName: 'ServicingService::Status',
  operatorName: 'ServicingService::Examiner',
  eventType: 'ServicingService::EventType',
  doneOn: 'ServicingService::DoneOn',
  dueOn: 'ServicingService::DueOn',
  status: 'ServicingService::Status',
  state: 'ServicingService::State',
  jobNumber: 'ServicingService::JobNumber',
  reportNumber: 'ServicingService::ReportNumber',
  notes: 'ServicingService::Notes',
  consumables: 'RegisterService::Menu:Consumables',
  cost: 'ServicingService::Cost',
  hourLimit: 'RegisterService::DueHrs',
  currentHours: 'RegisterService::DoneHrs',
  kmLimit: 'RegisterService::DueKm',
  mileLimit: 'ServicingService::DueMile',
  currentKm: 'RegisterService::DoneKm',
  currentMile: 'ServicingService::DoneMile',
  runningCost: 'RegisterService::EventCost',
  eventCost: 'RegisterService::EventCost',
  picture: 'RegisterService::Picture',
};
